import { HhsgSharedUserApplication } from './user-application.model';

export class HhsgSharedUserProfile {
    userId: number;
    clientId: string;
    email: string;
    firstName: string;
    lastName: string;
    applicationId: string;
    isSsoUser: boolean;
    brandingImage: string;
    brandingName: string;
    corporationId: string;
    roles: string[] = [];
    userApplications?: Array<HhsgSharedUserApplication>;
    isRootAdmin: boolean = false;

    public hasApplication(applicationAbbreviation: string) : boolean {
        return this.userApplications && this.userApplications.findIndex(app => app.abbreviation == applicationAbbreviation) >= 0;
    }
  
    constructor(params?: HhsgSharedUserProfile) {
        if (params) {
            this.userId = params.userId;
            this.clientId = params.clientId;
            this.email = params.email;
            this.firstName = params.firstName;
            this.lastName = params.lastName;
            this.applicationId = params.applicationId;
            this.isSsoUser = params.isSsoUser;
            this.brandingImage = params.brandingImage;
            this.brandingName = params.brandingName;
            this.corporationId = params.corporationId;
            this.roles = params.roles;
            this.userApplications = params.userApplications;
            this.isRootAdmin = params.isRootAdmin;
        }        
    }
}
